import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import { Box } from "@material-ui/core";

const pill = { borderRadius: 20 };

const RadioRows = ({
  labels,
  columns = 1,
}: {
  labels: number[];
  columns?: 1 | 2;
}) => (
  <Box
    className={`search-radios${columns === 2 ? " search-radios--two-col" : ""}`}
  >
    {labels.map((width, index) => (
      <Box
        key={index}
        style={{ display: "flex", alignItems: "center", gap: 8, minHeight: 32 }}
      >
        <Skeleton variant="circle" width={18} height={18} />
        <Skeleton variant="text" width={width} height={20} />
      </Box>
    ))}
  </Box>
);

const SelectField = ({ labelWidth }: { labelWidth: number }) => (
  <Box className="salary-field-row">
    <Skeleton variant="text" width={labelWidth} height={18} />
    <Skeleton variant="rect" width="100%" height={40} style={pill} />
  </Box>
);

const JobSidebarLoader = () => {
  return (
    <Box className="job-sidebar">
      <Box className="search-option">
        <h5>Posted Time</h5>
        <RadioRows labels={[72, 96, 108]} />
      </Box>

      <Box className="search-option">
        <h5>Job Location</h5>
        <Skeleton
          className="job-location-search"
          variant="rect"
          width="100%"
          height={40}
          style={{ ...pill, marginBottom: 12 }}
        />
        <RadioRows columns={2} labels={[36, 64, 68, 58]} />
      </Box>

      <Box className="search-option">
        <h5>Job Type</h5>
        <RadioRows labels={[36, 78, 76, 72, 80]} />
      </Box>

      <Box className="search-option">
        <h5>Experience Level</h5>
        <RadioRows labels={[36, 92, 104, 64, 60]} />
      </Box>

      <Box className="search-option">
        <h5>Salary Range</h5>
        <SelectField labelWidth={108} />
        <SelectField labelWidth={72} />
        <Skeleton
          variant="rect"
          width="100%"
          height={4}
          style={{ borderRadius: 4, margin: "8px 0 16px" }}
        />
        <Box className="salary-values">
          <Skeleton variant="rect" width={88} height={32} style={pill} />
          <Skeleton variant="rect" width={88} height={32} style={pill} />
        </Box>
      </Box>
    </Box>
  );
};

export default JobSidebarLoader;
